import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from './data.service';
import { Observable } from 'rxjs';
import { PhysicianFilter } from '../model/physician-Filter';
import { ReplacementPhysician } from '../model/replacement-physician';
import { ReferringPhysicianFilter, ReferringPhysicianSpecialityFilter } from '../model/referring-physician';
import { ReferringPhysicianView } from '../model/referring-physician/referring-physician-view';
import { ReferringPhysicianEditInfo } from '../model/referring-physician/referring-physician-edit-info';
import { RelevanceReferringPhysicianFilter } from '../model/referring-physician/relevance-referring-physician-filter';


@Injectable()
export class PhysicianService {

  constructor(private http: HttpClient, private dataService: DataService) { }

  private readonly getReferringPhysicianSpecialityFiltersEndPoint: string
    = '/physician/getReferringPhysicianSpecialityFilters/';
  private readonly getRelevanceReferringPhysicianFiltersEndPoint: string
    = '/physician/getRelevanceReferringPhysicianFilters/';
  private readonly referringPhysicianUpdateEndPoint: string
    = '/physician/referringPhysicianUpdate/';
  private readonly getReferringPhysicianEditInfoEndPoint: string
    = '/physician/getReferringPhysicianEditInfo/';
  private readonly getPosibleReportPhysicianFiltersEndPoint: string
    = '/physician/getPosibleReportPhysicianFilters/'; 
  private readonly getPosibleReportPhysicianByReportIdsFiltersEndPoint: string
    = '/physician/getPosibleReportPhysicianByReportIdsFilters/';  
  private readonly getReferringPhysicianViewByMedicalAppointmentIdEndPoint: string
        = '/physician/getReferringPhysicianViewByMedicalAppointmentId/';
  private readonly getReferringPhysicianViewEndPoint: string
    = '/physician/getReferringPhysicianView/';
  private readonly getPhysiciansFilterEndPoint: string
    = '/physician/GetPhysiciansFilter/';
  private readonly getReferringPhysiciansFilterEndPoint: string
    = '/physician/getReferringPhysiciansFilter/';
  private readonly getReplacementPhysiciansFilterEndPoint: string
    = '/physician/getReplacementPhysiciansFilter/';
  private readonly replacementMedicalApponitmentPhysicianEndPoint: string
    = '/physician/replacementMedicalApponitmentPhysician/';
  private readonly getPhysicianFilterEndPoint: string
    = '/physician/getPhysicianFilter/';

  async getPhysicianFilter( phisicianId: number ): Promise<PhysicianFilter> {

    const params = { phisicianId };
    return await this.dataService.get<PhysicianFilter>
      (this.getPhysicianFilterEndPoint, params).toPromise();
  }

  async getReferringPhysicianSpecialityFilters(): Promise<ReferringPhysicianSpecialityFilter[]> {
    return await this.dataService.get<ReferringPhysicianSpecialityFilter[]>
    (this.getReferringPhysicianSpecialityFiltersEndPoint, {}).toPromise();
  }

  async getRelevanceReferringPhysicianFilters(): Promise<RelevanceReferringPhysicianFilter[]> {
    return await this.dataService.get<RelevanceReferringPhysicianFilter[]>
    (this.getRelevanceReferringPhysicianFiltersEndPoint, {}).toPromise();
  }

  async referringPhysicianUpdate(referringPhysicianEditInfo: ReferringPhysicianEditInfo): Promise<number> {
    return await this.dataService.post<number>
    (this.referringPhysicianUpdateEndPoint, referringPhysicianEditInfo).toPromise();
  }

  async getReferringPhysicianEditInfo(referringPhysicianId: number): Promise<ReferringPhysicianEditInfo> {
    const params = { referringPhysicianId: referringPhysicianId};
    return await this.dataService.get<ReferringPhysicianEditInfo>
    (this.getReferringPhysicianEditInfoEndPoint, params).toPromise();
  }

  async getReferringPhysicianViewByMedicalAppointmentId(medicalAppointmentId: number): Promise<ReferringPhysicianView> {
    const params = { medicalAppointmentId: medicalAppointmentId};
    return await this.dataService.get<ReferringPhysicianView>
    (this.getReferringPhysicianViewByMedicalAppointmentIdEndPoint, params).toPromise();
  }

  async getReferringPhysicianView(referringPhysicianId: number): Promise<ReferringPhysicianView> {
    const params = { referringPhysicianId: referringPhysicianId};
    return await this.dataService.get<ReferringPhysicianView>(this.getReferringPhysicianViewEndPoint, params).toPromise();
  }

  async replacementMedicalApponitmentPhysician(replacementPhysician: ReplacementPhysician): Promise<boolean> {
    return await this.dataService.post<boolean>(this.replacementMedicalApponitmentPhysicianEndPoint, replacementPhysician).toPromise();
  }

  async getReplacementPhysicianFilters(medicalAppointmentId: number): Promise<PhysicianFilter[]> {
    const params = { medicalAppointmentId: medicalAppointmentId};
    return await this.dataService.get<PhysicianFilter[]>(this.getReplacementPhysiciansFilterEndPoint, params).toPromise();
  }

  

  async getPosibleReportPhysicianFilters(medicalAppointmentId: number): Promise<PhysicianFilter[]> {

    const params = { medicalAppointmentId: medicalAppointmentId};
    return await this.dataService.get<PhysicianFilter[]>
        (this.getPosibleReportPhysicianFiltersEndPoint, params).toPromise();
  }

  async getPosibleReportPhysicianByReportIdsFilters(reportIds: number[]): Promise<PhysicianFilter[]> {

    const params = { reportIds: JSON.stringify(reportIds)};
    return await this.dataService.get<PhysicianFilter[]>
        (this.getPosibleReportPhysicianByReportIdsFiltersEndPoint, params).toPromise();
  }


  async getPhysiciansFilter(practiceRegionIds: number[] = null): Promise<PhysicianFilter[]> {

    let practiceRegionIdsString = '';
    if (practiceRegionIds) {
      practiceRegionIdsString = JSON.stringify(practiceRegionIds);
    }

    const params = {
      practiceRegionIds: practiceRegionIdsString
    };

    return await this.dataService.get<PhysicianFilter[]>(this.getPhysiciansFilterEndPoint, params).toPromise();
  }

  getReferringPhysiciansFilter(filter: string): Observable<ReferringPhysicianFilter[]> {

    if (!filter || filter === '') {
      return new Observable<ReferringPhysicianFilter[]>();
    }

    const params = { filter: filter};
    return this.dataService.get<ReferringPhysicianFilter[]>(this.getReferringPhysiciansFilterEndPoint, params);
  }
}
